// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Settings_container__nhymk {
  max-width: 360px;
  margin: 40px auto;
  background: #ffffff;
  padding: 24px 28px;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  transition: all 0.2s ease-in-out;
}

.Settings_container__nhymk:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1);
}

.Settings_heading__Qdans {
  font-size: 1.4rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 0.2px;
}

.Settings_settingRow__0dIim {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  font-size: 1rem;
  color: #444;
}

/* 🧩 Switch toggle */
.Settings_switch__oTE7N {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 26px;
}

.Settings_switch__oTE7N input {
  opacity: 0;
  width: 0;
  height: 0;
}

.Settings_slider__M2Gft {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d3d3d3;
  transition: 0.3s;
  border-radius: 30px;
}

.Settings_slider__M2Gft:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: #fff;
  transition: 0.3s;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

input:checked + .Settings_slider__M2Gft {
  background-color: #4caf50;
}

input:checked + .Settings_slider__M2Gft:before {
  transform: translateX(22px);
}

.Settings_note__OmUbF {
  text-align: center;
  font-size: 0.95rem;
  color: #666;
  margin-top: 8px;
  -webkit-user-select: none;
          user-select: none;
}

/* 🌙 Dark mode support (optional) */
@media (prefers-color-scheme: dark) {
  .Settings_container__nhymk {
    background: #1f1f1f;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.6);
  }

  .Settings_heading__Qdans {
    color: #f5f5f5;
  }

  .Settings_settingRow__0dIim {
    color: #ddd;
  }

  .Settings_note__OmUbF {
    color: #aaa;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/Settings.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,0DAA0D;EAC1D,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE;IACE,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".container {\n  max-width: 360px;\n  margin: 40px auto;\n  background: #ffffff;\n  padding: 24px 28px;\n  border-radius: 16px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n  font-family: \"Inter\", system-ui, -apple-system, sans-serif;\n  transition: all 0.2s ease-in-out;\n}\n\n.container:hover {\n  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1);\n}\n\n.heading {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #222;\n  margin-bottom: 20px;\n  text-align: center;\n  letter-spacing: 0.2px;\n}\n\n.settingRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 20px 0;\n  font-size: 1rem;\n  color: #444;\n}\n\n/* 🧩 Switch toggle */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 26px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #d3d3d3;\n  transition: 0.3s;\n  border-radius: 30px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 3px;\n  bottom: 3px;\n  background-color: #fff;\n  transition: 0.3s;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\ninput:checked + .slider {\n  background-color: #4caf50;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(22px);\n}\n\n.note {\n  text-align: center;\n  font-size: 0.95rem;\n  color: #666;\n  margin-top: 8px;\n  user-select: none;\n}\n\n/* 🌙 Dark mode support (optional) */\n@media (prefers-color-scheme: dark) {\n  .container {\n    background: #1f1f1f;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.6);\n  }\n\n  .heading {\n    color: #f5f5f5;\n  }\n\n  .settingRow {\n    color: #ddd;\n  }\n\n  .note {\n    color: #aaa;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Settings_container__nhymk`,
	"heading": `Settings_heading__Qdans`,
	"settingRow": `Settings_settingRow__0dIim`,
	"switch": `Settings_switch__oTE7N`,
	"slider": `Settings_slider__M2Gft`,
	"note": `Settings_note__OmUbF`
};
export default ___CSS_LOADER_EXPORT___;
